import { OptionTitle } from "./OptionTitle"

export const MedicalHistoryOptions: Array<OptionTitle> = [
  { title: "Two or more miscarriages experienced by a partner", id: "TWO_PLUS_MISCARRIAGES_BY_PARTNER" },
  { title: "Sexually transmitted infection (STD/STI)", id: "STD_STI" },
  { title: "Varicocele", id: "VARICOCELE" },
  { title: "Mumps", id: "MUMPS" },
  { title: "Vasectomy", id: "VASECTOMY" },
  { title: "Vasectomy reversal", id: "VASECTOMY_REVERSAL" },
  { title: "Hernia repair (inguinal or groin)", id: "HERNIA_REPAIR" },
  { title: "Testicular surgery", id: "TESTICULAR_SURGERY" },
  {
    title: "Erectile dysfunction, ejaculatory dysfunction, or difficulty with intercourse",
    id: "ERECTILE_DYSFUNCTION"
  },
  { title: "Pelvic inflammatory disease (PID)", id: "PID" },
  { title: "Infection in the pelvis or abdomen", id: "INFECTION_PELVIC_ABDOMEN" },
  { title: "Endometriosis", id: "ENDOMETRIOSIS" },
  { title: "Uterine fibroids", id: "UTERINE_FIBROIDS" },
  { title: "Uterine scarring or Asherman syndrome", id: "UTERINE_SCARRING_ASHERMAN" },
  { title: "Uterine polyps", id: "UTERINE_POLYPS" },
  { title: "Polycystic ovary syndrome (PCOS)", id: "PCOS" },
  { title: "Pain or difficulty with intercourse", id: "PAIN_INTERCOURSE" },
  { title: "Pelvic or abdominal surgery", id: "PELVIC_ABDOMEN_SURGERY" }
]

export const ConditionsOptions: Array<OptionTitle> = [
  { title: "High blood pressure", id: "HIGH_BLOOD_PRESSURE" },
  { title: "Autoimmune disease that affects your hormones ", id: "HORMONE_AFFECTING_AUTOIMMUNE_DISEASE" },
  { title: "Other", id: "OTHER" },
  { title: "Diabetes", id: "DIABETES" },
  { title: "Autoimmune disease", id: "AUTOIMMUNE_DISEASE" },
  { title: "Obesity (BMI greater than 30)", id: "OBESITY" },
  { title: "Thyroid disorder", id: "THYROID_DISORDER" },
  { title: "Blood clotting or bleeding disorder", id: "BLOOD_CLOTTING_BLEEDING_DISORDER" }
]

export const FamilyConditionsOptions: Array<OptionTitle> = [
  { title: "Infertility", id: "INFERTILITY" },
  { title: "Recurrent pregnancy loss", id: "RECURRENT_PREGNANCY_LOSS" },
  { title: "Menopause before age 40", id: "MENOPAUSE_BEFORE_40" },
  { title: "Blood clotting or bleeding disorder", id: "BLOOD_CLOTTING_BLEEDING_DISORDER" },
  { title: "Chronic disease such as diabetes or high blood pressure", id: "CHRONIC_DISEASE" },
  { title: "Birth defects or genetic disorders", id: "BIRTH_DEFECTS_GENETIC_DISORDERS" }
]

export const CurrentlyTakingOptions: Array<OptionTitle> = [
  { title: "Prenatal vitamins", id: "PRENATAL_VITAMINS" },
  { title: "Vitamin D", id: "VITAMIN_D" },
  { title: "Contraceptive such as birth control pills, IUD, implant, or injectable", id: "CONTRACEPTIVE" },
  { title: "Hormones", id: "HORMONES" },
  { title: "Multivitamin", id: "MULTIVITAMIN" },
  { title: "Testosterone", id: "TESTOSTERONE" },
  { title: "Performance enhancing supplements or steroids", id: "PERFORMANCE_ENHANCING_SUPPLEMENTS_STEROIDS" },
  { title: "Other hormone", id: "OTHER_HORMONE" }
]

export const SmokeDrinkOptions: Array<OptionTitle> = [
  { title: "I smoke cigarettes daily", id: "CIGARETTES_DAILY" },
  { title: "I quit smoking", id: "QUIT_SMOKING" },
  { title: "I use marijuana", id: "MARIJUANA" },
  { title: "I exercise regularly", id: "EXERCISE_REGULARLY" },
  { title: "I consume three or more servings of alcohol a week", id: "THREE_PLUS_ALCOHOLS_WEEKLY" },
  { title: "I consume one or more servings of caffeine a day", id: "ONE_PLUS_COFFEE_DAILY" },
  {
    title: "I have had environmental exposure at a level known to impact fertility",
    id: "ENVIRONMENTAL_EXPOSURE_IMPACTING_FERTILITY"
  },
  {
    title: "I have had radiation exposure at a level known to impact fertility",
    id: "RADIATION_EXPOSURE_IMPACTING_FERTILITY"
  }
]

export const ExperiencingSymptomsOptions: Array<OptionTitle> = [
  { title: "Moderate to severe acne", id: "ACNE" },
  {
    title: "Unexpected hair growth on the face, chest, nipples, lower abdomen, or lower back",
    id: "UNEXPECTED_HAIR_GROWTH"
  },
  { title: "Significant hair loss", id: "HAIR_LOSS" },
  { title: "Unexplained weight gain or loss", id: "WEIGHT_CHANGE" },
  { title: "Chronic fatigue", id: "CHRONIC_FATIGUE" },
  { title: "Heart racing or palpitations", id: "HEART_RACING_PALPITATIONS" },
  { title: "Irritability or mood changes", id: "IRRITABILITY_MOOD_CHANGES" }
]

export const CycleDetails: Array<OptionTitle> = [
  { title: "I’ve never had a menstrual cycle", id: "NEVER_HAD_PERIOD" },
  { title: "Sometimes I skip months", id: "SKIP_MONTHS" },
  { title: "I have bleeding or spotting in between my expected cycles", id: "SPOTTING_BETWEEN" },
  { title: "I'm not sure", id: "NOT_SURE" },
  { title: "I have not had a menstrual cycle in more than 12 months", id: "NO_MENSTRUAL_CYCLE_OVER_12_MONTHS" },
  { title: "My cycles have always been affected by hormones/contraception", id: "CYCLES_AFFECTED_BY_HORMONES" }
]

export const PeriodsPainfulDetails: Array<OptionTitle> = [
  { title: "Pain with intercourse", id: "PAINFUL_INTERCOURSE" },
  { title: "Pain with bowel movements or urination", id: "PAINFUL_BOWEL_URINATION" },
  { title: "Very heavy bleeding", id: "HEAVY_BLEEDING" }
]

export const PregnantPreviouslyDetails: Array<OptionTitle> = [
  { title: "Preterm birth", id: "PRETERM_BIRTH" },
  { title: "Unintended pregnancy loss", id: "UNINTENDED_LOSS" },
  { title: "Pregnancy achieved via fertility treatment", id: "VIA_FERTILITY_TREATMENT" },
  { title: "Ectopic pregnancy", id: "ECTOPIC_PREGNANCY" },
  { title: "High blood pressure", id: "HIGH_BLOOD_PRESSURE" },
  { title: "High blood sugar", id: "HIGH_BLOOD_SUGAR" },
  { title: "Depression or other emotional challenges", id: "DEPRESSION_OTHER_CHALLENGES" }
]

export const MenopauseDiagnosisDetails: Array<OptionTitle> = [
  { title: "I have been diagnosed with premature ovarian failure", id: "PREMATURE_OVARIAN_FAILURE" },
  { title: "I was diagnosed with menopause at under 40 year of age", id: "MENOPAUSE_UNDER_40" },
  { title: "I was diagnosed with menopause at over 40 year of age", id: "MENOPAUSE_OVER_40" }
]

export const MenopauseSymptoms: Array<OptionTitle> = [
  { title: "Hot flashes", id: "HOT_FLASHES" },
  { title: "Vaginal dryness", id: "VAGINAL_DRYNESS" },
  { title: "Decreased interest in sexual intercourse", id: "DECREASED_INTEREST_INTERCOURSE" },
  { title: "Pain or discomfort during intercourse", id: "PAIN_DURING_INTERCOURSE" },
  { title: "Bleeding after intercourse", id: "BLEEDING_AFTER_INTERCOURSE" },
  { title: "Soreness, itching, or burning around the vaginal entrance", id: "SORENESS_AROUND_VAGINAL_ENTRANCE" },
  { title: "Unexplained weight gain", id: "UNEXPLAINED_WEIGHT_GAIN" },
  { title: "Problems with sleep (frequent waking)", id: "SLEEP_PROBLEMS" },
  { title: "Mood changes", id: "MOOD_CHANGES" },
  { title: "Forgetfulness", id: "FORGETFULNESS" }
]

export const PelvicSurgeryDetails: Array<OptionTitle> = [
  { title: "Bilateral tubal ligation (”tied my tubes”)", id: "TUBES_TIED" },
  { title: "Other tubal surgery", id: "OTHER_TUBAL_SURGERY" },
  { title: "Removal of fibroids", id: "REMOVED_FIBROIDS" },
  { title: "Removal of polyps in uterus", id: "REMOVED_POLYPS_IN_UTERUS" },
  { title: "Removal of septum in uterus", id: "REMOVED_SEPTUM_IN_UTERUS" },
  { title: "Removal of uterus", id: "REMOVAL_OF_UTERUS" },
  { title: "One ovary removed", id: "ONE_OVARY_REMOVED" },
  { title: "Two ovaries removed", id: "TWO_OVARIES_REMOVED" }
]

export const LowTestosteroneSymptomsOptions: Array<OptionTitle> = [
  {
    title: "Decreased interest in sex",
    id: "DECREASED_INTEREST_SEX"
  },
  {
    title: "Erectile dysfunction, ejaculatory dysfunction, or difficulty with intercourse",
    id: "ERECTILE_DYSFUNCTION"
  },
  {
    title: "Fatigue or decreased energy",
    id: "FATIGUE_DECREASED_ENERGY"
  },
  {
    title: "Decreased muscular strength",
    id: "DECREASED_MUSCULAR_STRENGTH"
  },
  {
    title: "Depressed mood",
    id: "DEPRESSED_MOOD"
  },
  {
    title: "Irritability",
    id: "IRRITABILITY"
  }
]

export const CyclesAreRegularOptions: Array<OptionTitle> = [
  { title: "Yes", id: "YES" },
  { title: "No", id: "NO" },
  { title: "I'm not sure", id: "NOT_SURE" }
]

export const MentalHealthScreenerOptions: Array<OptionTitle> = [
  { title: "Not at all", id: "NOT_AT_ALL" },
  { title: "Several days", id: "SEVERAL_DAYS" },
  { title: "More than half the days", id: "MORE_THAN_HALF_THE_DAYS" },
  { title: "Nearly every day", id: "NEARLY_EVERY_DAY" }
]

export const BabyFeedingOptions: Array<OptionTitle> = [
  { title: "Breastmilk only", id: "BREASTFEEDING" },
  { title: "Formula only", id: "FORMULA" },
  { title: "Breastmilk and formula", id: "MIXED_FEEDING" },
  { title: "I'm unsure/haven't decided yet", id: "NOT_SURE" }
]

export const PregnancyReturnToWorkOptions: Array<OptionTitle> = [
  { title: "Yes", id: "WILL_RETURN_TO_WORK" },
  { title: "No", id: "WILL_NOT_RETURN_TO_WORK" },
  { title: "I'm not currently employed", id: "NOT_CURRENTLY_EMPLOYED" },
  { title: "I don't know yet", id: "NOT_SURE" }
]

export const PostpartumReturnToWorkOptions: Array<OptionTitle> = [
  {
    title: "I’m on leave and plan to return to work",
    id: "ON_LEAVE_PLAN_TO_RETURN"
  },
  {
    title: "I’m on leave and do not plan to return to work",
    id: "ON_LEAVE_DO_NOT_PLAN_TO_RETURN"
  },
  {
    title: "I already took leave and have returned to work",
    id: "TOOK_LEAVE_HAVE_RETURNED"
  },
  {
    title: "I already took leave and did not return to work",
    id: "TOOK_LEAVE_DID_NOT_RETURN"
  },
  { title: "I did not take leave", id: "DID_NOT_TAKE_LEAVE" },
  { title: "I'm not currently employed", id: "NOT_CURRENTLY_EMPLOYED" },
  { title: "I haven’t decided yet", id: "HAVE_NOT_DECIDED" }
]
export const PregnancyRaceEthnicityOptions: Array<OptionTitle> = [
  {
    title: "Black and/or African",
    id: "BLACK_AFRICAN"
  },
  {
    title: "Middle Eastern and/or North African",
    id: "MIDDLE_EASTERN_NORTH_AFRICAN"
  },
  { title: "White and/or European", id: "WHITE_EUROPEAN" },
  { title: "East Asian", id: "EAST_ASIAN" },
  {
    title: "South Asian",
    id: "SOUTH_ASIAN"
  },
  { title: "Southeast Asian", id: "SOUTHEAST_ASIAN" },
  {
    title: "Hispanic and/or Latine",
    id: "HISPANIC_LATINE"
  },
  {
    title: "Indigenous and/or First Nations",
    id: "INDIGENOUS_FIRST_NATIONS"
  },
  { title: "I prefer not to answer", id: "PREFER_NOT_TO_ANSWER" }
]
